(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-news-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smartkat-home-news')) {
    customElements.define('smartkat-home-news', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        this.loadNews();
      }

      async loadNews() {
        const grid = this.querySelector('[data-news-grid]');
        const status = this.querySelector('[data-news-status]');
        status.hidden = false;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const url = new URL(this.dataset.newsUrl, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('News must use the same store.');
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-cache', signal: controller.signal });
          if (!response.ok) throw new Error('News unavailable.');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...page.querySelectorAll('[data-smartkat-news-item]')]
            .filter(item => item.querySelector('h2, h3')?.textContent.trim())
            .sort((a, b) => Number(a.dataset.newsOrder) - Number(b.dataset.newsOrder))
            .slice(0, 2);
          if (!items.length) throw new Error('No news items.');
          const fragment = document.createDocumentFragment();
          for (const item of items) {
            const article = document.createElement('article');
            article.className = 'sk-home-news-promo__card';
            const image = item.querySelector('img');
            if (image) {
              const imageUrl = new URL(image.getAttribute('src'), url);
              if (['http:', 'https:'].includes(imageUrl.protocol)) {
                const media = document.createElement('a');
                media.className = 'sk-home-news-promo__media';
                media.href = this.storyUrl(item.id);
                media.tabIndex = -1;
                media.setAttribute('aria-hidden', 'true');
                const thumbnail = document.createElement('img');
                thumbnail.src = imageUrl.href;
                thumbnail.alt = '';
                thumbnail.width = 560;
                thumbnail.height = 315;
                thumbnail.loading = 'lazy';
                thumbnail.decoding = 'async';
                media.append(thumbnail);
                article.append(media);
              }
            }
            const copy = document.createElement('div');
            copy.className = 'sk-home-news-promo__copy';
            const tag = document.createElement('p');
            tag.className = 'sk-home-news-promo__tag';
            tag.textContent = item.querySelector('.sk-news-page__tag')?.textContent.trim() || '';
            const title = document.createElement('h3');
            const link = document.createElement('a');
            link.href = this.storyUrl(item.id);
            link.textContent = item.querySelector('h2, h3').textContent.trim();
            title.append(link);
            const text = document.createElement('p');
            text.className = 'sk-home-news-promo__text';
            const summary = item.querySelector('.sk-news-page__featured-copy > p:not(.sk-news-page__tag), .sk-news-page__item-copy > p')?.textContent.trim() || '';
            text.textContent = summary.length > 210 ? summary.slice(0, 207).replace(/\s+\S*$/, '') + '…' : summary;
            const read = document.createElement('a');
            read.className = 'sk-home-news-promo__read';
            read.href = this.storyUrl(item.id);
            read.textContent = this.dataset.readLabel + ' →';
            read.setAttribute('aria-label', this.dataset.readLabel + ': ' + link.textContent);
            copy.append(tag, title, text, read);
            article.append(copy);
            fragment.append(article);
          }
          grid.replaceChildren(fragment);
          status.hidden = true;
          this.dataset.state = 'ready';
        } catch (_) {
          status.textContent = this.dataset.unavailableLabel;
          this.dataset.state = 'unavailable';
        } finally {
          clearTimeout(timeout);
        }
      }

      storyUrl(id) {
        const url = new URL(this.dataset.newsUrl, window.location.origin);
        url.hash = id;
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url.href;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartkat-video-library"] && !Shopify.designMode) return;
  try {
    
  const initializeSmartkatVideoCatalog = (scope = document) => {
    scope.querySelectorAll('[data-video-catalog]').forEach((catalog) => {
      if (catalog.dataset.paginationReady === 'true') return;

      const items = Array.from(catalog.querySelectorAll('[data-video-item]'));
      const buttons = Array.from(catalog.querySelectorAll('[data-video-page-button]'));
      if (!items.length) return;

      const pageCount = Math.max(1, Math.ceil(items.length / 12));
      const requestedPage = Number.parseInt(new URLSearchParams(window.location.search).get('video_page') || '1', 10);
      const initialPage = Math.min(Math.max(Number.isFinite(requestedPage) ? requestedPage - 1 : 0, 0), pageCount - 1);

      const showPage = (pageIndex, moveFocus = false) => {
        items.forEach((item) => {
          const isVisible = Number(item.dataset.videoPage) === pageIndex;
          item.hidden = !isVisible;
          if (!isVisible) item.querySelector('smartkat-video-player')?.resetPlayer?.();
        });

        buttons.forEach((button) => {
          const isCurrent = Number(button.dataset.videoPageButton) === pageIndex;
          if (isCurrent) {
            button.setAttribute('aria-current', 'page');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        if (moveFocus) {
          const url = new URL(window.location.href);
          if (pageIndex === 0) {
            url.searchParams.delete('video_page');
          } else {
            url.searchParams.set('video_page', String(pageIndex + 1));
          }
          window.history.replaceState({}, '', url);
          catalog.scrollIntoView({ behavior: 'auto', block: 'start' });
          items.find((item) => !item.hidden)?.querySelector('h2, h3')?.focus?.({ preventScroll: true });
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => showPage(Number(button.dataset.videoPageButton), true));
      });

      catalog.dataset.paginationReady = 'true';
      showPage(initialPage);
    });
  };

  initializeSmartkatVideoCatalog();
  document.addEventListener('shopify:section:load', (event) => initializeSmartkatVideoCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testsegeln-lipno"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.sk-lipno');
    if (!root) return;

    const panel = root.querySelector('.sk-lipno__booking-panel');
    const daysEl = root.querySelector('#sk-lipno-days');
    const timesEl = root.querySelector('#sk-lipno-times');
    const summaryEl = root.querySelector('#sk-lipno-summary');
    const submitButton = root.querySelector('#sk-lipno-submit');
    const hiddenDate = root.querySelector('#sk-lipno-hidden-date');
    const hiddenTime = root.querySelector('#sk-lipno-hidden-time');
    const subject = root.querySelector('#sk-lipno-subject');
    const body = root.querySelector('#sk-lipno-body');
    const form = root.querySelector('#sk-lipno-form');

    const dates = [
      { iso: '2026-07-17', label: 'Fr 17.07.', times: ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'] },
      { iso: '2026-07-18', label: 'Sa 18.07.', times: ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'] },
      { iso: '2026-07-19', label: 'So 19.07.', times: ['10:00', '11:00', '12:00'] }
    ];

    let selectedDate = '';
    let selectedDateLabel = '';
    let selectedTime = '';
    let blocked = new Set();

    try {
      blocked = new Set(JSON.parse(panel.dataset.blocked || '[]'));
    } catch (error) {
      blocked = new Set();
    }

    function renderDays() {
      daysEl.innerHTML = '';
      dates.forEach(function (day) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sk-lipno__date-button';
        button.textContent = day.label;
        button.setAttribute('aria-pressed', selectedDate === day.iso ? 'true' : 'false');
        if (selectedDate === day.iso) button.classList.add('is-selected');
        button.addEventListener('click', function () {
          selectedDate = day.iso;
          selectedDateLabel = day.label;
          selectedTime = '';
          renderDays();
          renderTimes();
          updateSummary();
        });
        daysEl.appendChild(button);
      });
    }

    function renderTimes() {
      timesEl.innerHTML = '';
      const selectedDay = dates.find(function (day) {
        return day.iso === selectedDate;
      });
      const times = selectedDay ? selectedDay.times : [];
      times.forEach(function (time) {
        const key = selectedDate + ' ' + time;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sk-lipno__time-button';
        button.textContent = time;
        button.setAttribute('aria-pressed', selectedTime === time ? 'true' : 'false');
        if (blocked.has(key)) {
          button.disabled = true;
          button.textContent = time + ' belegt';
        } else {
          button.addEventListener('click', function () {
            selectedTime = time;
            renderTimes();
            updateSummary();
          });
        }
        if (selectedTime === time) button.classList.add('is-selected');
        timesEl.appendChild(button);
      });
    }

    function updateSummary() {
      const hasSelection = selectedDate && selectedTime;
      submitButton.disabled = !hasSelection;
      hiddenDate.value = selectedDate;
      hiddenTime.value = selectedTime;
      if (!hasSelection) {
        summaryEl.textContent = selectedDate ? 'Bitte noch eine Uhrzeit waehlen.' : 'Noch kein Termin ausgewaehlt.';
        return;
      }
      summaryEl.textContent = 'Ausgewaehlt: ' + selectedDateLabel + ' um ' + selectedTime + ' Uhr';
      subject.value = 'Testsegeln Lipno Anmeldung: ' + selectedDate + ' ' + selectedTime;
    }

    if (form) {
      form.addEventListener('submit', function () {
        const getValue = function (name) {
          const field = form.querySelector('[name="contact[' + name + ']"]');
          return field ? field.value : '';
        };
        body.value = [
          'Neue Anmeldung fuer smartkat Testsegeln Lipno / Marek',
          '',
          'Datum: ' + selectedDate,
          'Uhrzeit: ' + selectedTime + ' Uhr',
          'Personen: ' + getValue('personen'),
          '',
          'Name: ' + getValue('name'),
          'E-Mail: ' + getValue('email'),
          'Telefon: ' + (getValue('phone') || '-'),
          '',
          'Nachricht:',
          getValue('nachricht') || '-',
          '',
          'Hinweis: genauen Treffpunkt am Lipno-Stausee erst nach persoenlicher Terminbestaetigung senden.',
          'Slot zum Blockieren im Metaobject booking_block: ' + selectedDate + ' ' + selectedTime
        ].join('\n');
      });
    }

    renderDays();
    updateSummary();

    if (window.location.search.indexOf('contact_posted=true') > -1) {
      root.querySelector('#anmeldung').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testsegeln-standort"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.sk-wolf');
    if (!root) return;

    const panel = root.querySelector('.sk-wolf__booking-panel');
    const peopleEl = root.querySelector('#sk-wolf-people');
    const form = root.querySelector('#sk-wolf-form');
    const body = root.querySelector('#sk-wolf-body');
    const subject = root.querySelector('#sk-wolf-subject');

    let selectedPeople = '2';

    // ---- Personenzahl (in beiden Betriebsarten) ----
    const hiddenPeople = root.querySelector('#sk-wolf-hidden-people');

    function renderPeople() {
      if (!peopleEl) return;
      peopleEl.innerHTML = '';
      ['1', '2', '3', '4'].forEach(function (count) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sk-wolf__people-button';
        button.textContent = count;
        button.setAttribute('aria-pressed', selectedPeople === count ? 'true' : 'false');
        if (selectedPeople === count) button.classList.add('is-selected');
        button.addEventListener('click', function () {
          selectedPeople = count;
          if (hiddenPeople) hiddenPeople.value = count;
          renderPeople();
        });
        peopleEl.appendChild(button);
      });
    }

    renderPeople();

    // ---- Betriebsart A: feste Termine ----
    const daysEl = root.querySelector('#sk-wolf-days');
    const timesEl = root.querySelector('#sk-wolf-times');

    let selectedDate = '';
    let selectedDateLabel = '';
    let selectedTime = '';

    if (daysEl && timesEl) {
      const summaryEl = root.querySelector('#sk-wolf-summary');
      const submitButton = root.querySelector('#sk-wolf-submit');
      const hiddenDate = root.querySelector('#sk-wolf-hidden-date');
      const hiddenTime = root.querySelector('#sk-wolf-hidden-time');
      const hintEl = root.querySelector('#sk-wolf-times-hint');
      const dayButtons = Array.prototype.slice.call(daysEl.querySelectorAll('.sk-wolf__date-button'));
      const timeButtons = Array.prototype.slice.call(timesEl.querySelectorAll('.sk-wolf__time-button'));

      let blocked = new Set();
      try {
        blocked = new Set(JSON.parse(panel.dataset.blocked || '[]'));
      } catch (error) {
        blocked = new Set();
      }

      // Tage, an denen jede Uhrzeit belegt ist, gleich als ausgebucht kennzeichnen
      const allTimes = timeButtons.map(function (button) { return button.dataset.time; });
      dayButtons.forEach(function (button) {
        const iso = button.dataset.iso;
        const full = allTimes.length > 0 && allTimes.every(function (time) {
          return blocked.has(iso + ' ' + time);
        });
        if (full) {
          button.disabled = true;
          button.classList.add('is-blocked');
          const note = document.createElement('em');
          note.textContent = button.dataset.fullLabel || 'ausgebucht';
          button.appendChild(note);
        }
      });

      dayButtons.forEach(function (button) {
        if (button.disabled) return;
        button.addEventListener('click', function () {
          selectedDate = button.dataset.iso;
          selectedDateLabel = button.dataset.label;
          selectedTime = '';
          dayButtons.forEach(function (other) {
            const on = other === button;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          showTimes();
          updateSummary();
          timesEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });

      function showTimes() {
        if (hintEl) hintEl.hidden = true;
        timeButtons.forEach(function (button) {
          button.hidden = false;
          const key = selectedDate + ' ' + button.dataset.time;
          const isBlocked = blocked.has(key);
          button.disabled = isBlocked;
          button.classList.toggle('is-blocked', isBlocked);
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
      }

      timeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          selectedTime = button.dataset.time;
          timeButtons.forEach(function (other) {
            const on = other === button;
            other.classList.toggle('is-selected', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          updateSummary();
        });
      });

      function updateSummary() {
        const ready = selectedDate && selectedTime;
        submitButton.disabled = !ready;
        if (hiddenDate) hiddenDate.value = selectedDate;
        if (hiddenTime) hiddenTime.value = selectedTime;
        if (!summaryEl) return;
        if (!selectedDate) {
          summaryEl.classList.remove('is-ready');
          return;
        }
        if (!selectedTime) {
          summaryEl.classList.remove('is-ready');
          summaryEl.textContent = summaryEl.dataset.needTime || 'Fehlt nur noch die Uhrzeit.';
          return;
        }
        summaryEl.classList.add('is-ready');
        summaryEl.textContent = (summaryEl.dataset.ready || 'Dein Wunschtermin:') + ' ' + selectedDateLabel + ' ' + selectedTime;
        if (subject) subject.value = subject.value.split(':')[0] + ': ' + selectedDate + ' ' + selectedTime;
      }
    }

    // ---- Absenden: lesbare Zusammenfassung in die Mail ----
    if (form) {
      form.addEventListener('submit', function () {
        const getValue = function (name) {
          const field = form.querySelector('[name="contact[' + name + ']"]');
          return field ? field.value : '';
        };
        body.value = [
          'Neue Testsegel-Anfrage',
          '',
          'Ort: ' + getValue('Ort'),
          'Datum: ' + (getValue('datum') || '-'),
          'Uhrzeit: ' + (getValue('uhrzeit') || '-'),
          'Personen: ' + selectedPeople,
          '',
          'Name: ' + getValue('name'),
          'E-Mail: ' + getValue('email'),
          'Telefon: ' + (getValue('phone') || '-'),
          '',
          'Hinweis: genauen Treffpunkt erst nach persoenlicher Bestaetigung senden.',
          'Slot zum Blockieren im Metaobject booking_block: ' + getValue('datum') + ' ' + getValue('uhrzeit')
        ].join('\n');
      });
    }

    if (window.location.search.indexOf('contact_posted=true') > -1) {
      const target = root.querySelector('#anmeldung');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testsegeln-wolfgangsee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.sk-wolf');
    if (!root) return;

    const panel = root.querySelector('.sk-wolf__booking-panel');
    const daysEl = root.querySelector('#sk-wolf-days');
    const timesEl = root.querySelector('#sk-wolf-times');
    const peopleEl = root.querySelector('#sk-wolf-people');
    const summaryEl = root.querySelector('#sk-wolf-summary');
    const submitButton = root.querySelector('#sk-wolf-submit');
    const hiddenDate = root.querySelector('#sk-wolf-hidden-date');
    const hiddenTime = root.querySelector('#sk-wolf-hidden-time');
    const hiddenPeople = root.querySelector('#sk-wolf-hidden-people');
    const subject = root.querySelector('#sk-wolf-subject');
    const body = root.querySelector('#sk-wolf-body');
    const form = root.querySelector('#sk-wolf-form');

    const slotTimes = ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];

    const weeks = [
      {
        label: 'Diese Woche',
        days: [
          { iso: '2026-08-10', day: 'Mo', date: '10.08.' },
          { iso: '2026-08-11', day: 'Di', date: '11.08.' },
          { iso: '2026-08-12', day: 'Mi', date: '12.08.' },
          { iso: '2026-08-13', day: 'Do', date: '13.08.' }
        ]
      },
      {
        label: '17. bis 20. August',
        days: [
          { iso: '2026-08-17', day: 'Mo', date: '17.08.' },
          { iso: '2026-08-18', day: 'Di', date: '18.08.' },
          { iso: '2026-08-19', day: 'Mi', date: '19.08.' },
          { iso: '2026-08-20', day: 'Do', date: '20.08.' }
        ]
      },
      {
        label: '24. bis 27. August',
        days: [
          { iso: '2026-08-24', day: 'Mo', date: '24.08.' },
          { iso: '2026-08-25', day: 'Di', date: '25.08.' },
          { iso: '2026-08-26', day: 'Mi', date: '26.08.' },
          { iso: '2026-08-27', day: 'Do', date: '27.08.' }
        ]
      },
      {
        label: '31. August',
        days: [
          { iso: '2026-08-31', day: 'Mo', date: '31.08.' }
        ]
      }
    ];

    let selectedDate = '';
    let selectedDateLabel = '';
    let selectedTime = '';
    let selectedPeople = '2';
    let blocked = new Set();

    try {
      blocked = new Set(JSON.parse(panel.dataset.blocked || '[]'));
    } catch (error) {
      blocked = new Set();
    }

    function renderDays() {
      daysEl.innerHTML = '';
      weeks.forEach(function (week) {
        const heading = document.createElement('p');
        heading.className = 'sk-wolf__week-label';
        heading.textContent = week.label;
        daysEl.appendChild(heading);

        const row = document.createElement('div');
        row.className = 'sk-wolf__day-row';

        week.days.forEach(function (day) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sk-wolf__date-button';
          button.innerHTML = '<b>' + day.day + '</b><span>' + day.date + '</span>';
          button.setAttribute('aria-pressed', selectedDate === day.iso ? 'true' : 'false');
          if (selectedDate === day.iso) button.classList.add('is-selected');
          button.addEventListener('click', function () {
            selectedDate = day.iso;
            selectedDateLabel = day.day + ' ' + day.date;
            selectedTime = '';
            renderDays();
            renderTimes();
            updateSummary();
            timesEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          row.appendChild(button);
        });

        daysEl.appendChild(row);
      });
    }

    function renderTimes() {
      timesEl.innerHTML = '';
      if (!selectedDate) {
        const hint = document.createElement('p');
        hint.className = 'sk-wolf__hint';
        hint.textContent = 'Waehle zuerst einen Tag aus.';
        timesEl.appendChild(hint);
        return;
      }
      slotTimes.forEach(function (time) {
        const key = selectedDate + ' ' + time;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sk-wolf__time-button';
        button.textContent = time;
        button.setAttribute('aria-pressed', selectedTime === time ? 'true' : 'false');
        if (blocked.has(key)) {
          button.disabled = true;
          button.textContent = time;
          button.classList.add('is-blocked');
          button.setAttribute('aria-label', time + ' schon vergeben');
        } else {
          button.addEventListener('click', function () {
            selectedTime = time;
            renderTimes();
            updateSummary();
          });
        }
        if (selectedTime === time) button.classList.add('is-selected');
        timesEl.appendChild(button);
      });
    }

    function renderPeople() {
      peopleEl.innerHTML = '';
      ['1', '2', '3', '4'].forEach(function (count) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sk-wolf__people-button';
        button.textContent = count;
        button.setAttribute('aria-pressed', selectedPeople === count ? 'true' : 'false');
        if (selectedPeople === count) button.classList.add('is-selected');
        button.addEventListener('click', function () {
          selectedPeople = count;
          hiddenPeople.value = count;
          renderPeople();
        });
        peopleEl.appendChild(button);
      });
    }

    function updateSummary() {
      const hasSelection = selectedDate && selectedTime;
      submitButton.disabled = !hasSelection;
      hiddenDate.value = selectedDate;
      hiddenTime.value = selectedTime;
      if (!selectedDate) {
        summaryEl.className = 'sk-wolf__summary';
        summaryEl.textContent = 'Noch kein Tag ausgewaehlt.';
        return;
      }
      if (!selectedTime) {
        summaryEl.className = 'sk-wolf__summary';
        summaryEl.textContent = 'Fehlt nur noch die Uhrzeit.';
        return;
      }
      summaryEl.className = 'sk-wolf__summary is-ready';
      summaryEl.textContent = 'Dein Wunschtermin: ' + selectedDateLabel + ' um ' + selectedTime + ' Uhr';
      subject.value = 'Testsegeln Wolfgangsee Anfrage: ' + selectedDate + ' ' + selectedTime;
    }

    if (form) {
      form.addEventListener('submit', function () {
        const getValue = function (name) {
          const field = form.querySelector('[name="contact[' + name + ']"]');
          return field ? field.value : '';
        };
        body.value = [
          'Neue Anfrage fuer smartkat Testsegeln Wolfgangsee',
          '',
          'Datum: ' + selectedDate,
          'Uhrzeit: ' + selectedTime + ' Uhr',
          'Personen: ' + selectedPeople,
          '',
          'Name: ' + getValue('name'),
          'E-Mail: ' + getValue('email'),
          'Telefon: ' + (getValue('phone') || '-'),
          '',
          'Hinweis: genauen Treffpunkt am Wolfgangsee erst nach persoenlicher Bestaetigung senden.',
          'Slot zum Blockieren im Metaobject booking_block: ' + selectedDate + ' ' + selectedTime
        ].join('\n');
      });
    }

    renderDays();
    renderPeople();
    updateSummary();

    if (window.location.search.indexOf('contact_posted=true') > -1) {
      root.querySelector('#anmeldung').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
